// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__297Sp","tab":"ProcedureTabs_tab__2bApP"};